export function joinPath(...paths: string[]) {
	return paths
		.reduce(
			(parts: string[], path) =>
				parts.concat(
					(parts.length
						? path.replace(/^\//, "")
						: path.replace(/\/$/, "")
					).split("/"),
				),
			[],
		)
		.reduce((parts: string[], part: string) => {
			switch (part) {
				case ".":
					break;
				case "..":
					parts.pop();
					break;
				default:
					parts.push(part);
					break;
			}
			return parts;
		}, [])
		.join("/");
}

export function mapAsync<T, R>(
	arr: T[],
	cb: (value: T, index: number, array: T[]) => Promise<R>,
): Promise<R[]> {
	return arr.reduce(
		async (acc: Promise<R[]>, value: T, index: number) => [
			...(await acc),
			await cb(value, index, arr),
		],
		Promise.resolve([] as R[]),
	);
}

export async function batchForEach<T>(
	arr: T[],
	cb: (value: T, index: number, array: T[]) => Promise<void>,
	batchSize = 5,
) {
	for (let i = 0; i < arr.length; i += batchSize) {
		await Promise.all(
			arr
				.slice(i, i + batchSize)
				.map((val, index, arr) => cb(val, i + index, arr)),
		);
	}
}

/**
 * This method find next name, adds suffix
 * @param nameArr Unique names
 * @param name Name to create with
 * @returns {string} Returns next name
 */
export function findNextName(nameArr: string[], name: string): string {
	const regex = new RegExp(`^${name}_?(\\d+)?$`);
	const matches = nameArr.filter((item) => regex.test(item));
	if (matches.length === 0) {
		return name; // Return the original name if not present in the array
	}
	// Extract numeric suffixes from matches
	const suffixes = matches.map((match) => {
		const matchSuffix = match.match(/\d+$/);
		return matchSuffix ? Number.parseInt(matchSuffix[0]) : 0;
	});

	// Find the next available suffix
	let nextSuffix = 1;
	while (suffixes.includes(nextSuffix)) {
		nextSuffix++;
	}

	return `${name}_${nextSuffix}`;
}
